export function useSessionStorage<T>(key: string) {
  const getValue = (): T | null => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch {
      return null;
    }
  };

  const setValue = (value: T) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  };

  const removeValue = () => {
    sessionStorage.removeItem(key);
  };

  return { getValue, setValue, removeValue };
}
